/**
 * Passi guidati spuntati dai dati: quelli della squadra senza rosa (V06) e
 * quelli della societa senza squadre nella stagione corrente (V05).
 */

/**
 * I passi nell'ordine in cui si fanno, con il primo ancora da fare in
 * evidenza. Le spunte restano indipendenti: un passo fatto fuori ordine
 * risulta fatto, e il prossimo e comunque il primo che manca.
 */
export function segnaProssimo<T extends { fatto: boolean }>(
  passi: readonly T[],
): (T & { prossimo: boolean })[] {
  const primo = passi.findIndex((p) => !p.fatto);
  return passi.map((p, i) => ({ ...p, prossimo: i === primo }));
}
